import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required, noZeroStater } from '@validations'
import jalaali from 'moment-jalaali'
import DatePicker from 'vue-persian-datetime-picker'
import moment from '@/libs/moment'
import { alphanumeric } from '@/mixins/alphanumeric'
import ProfileApis from '@/services/apis/profile'
import FormApis from '@/services/apis/form'
import { toEnglishDigits } from '@/utils'

const formData = new FormApis()
const userProfile = new ProfileApis()
export default {
  components: {
    vSelect,
    DatePicker,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      required,
      noZeroStater,
      moment,
      jalaali,
      show: false,
      pending: false,
      codePending: false,
      registerPending: '',
      receive_code: '',
      mobile_country_code: '',
      mobile_number: '',
      residency: '',
      citizenship: '',
      userProfile: {
        profile: {},
      },
      formsListData: {
        gender: [],
        countries: [],
        pre_country_code: [],
      },
      convertedBirthdate: moment().format('YYYY-MM-DD'),
    }
  },

  computed: {
    profileInfoP() {
      return this.$store.state.profile.profileInfo
    },

    citizenshipName() {
      return this.userProfile?.citizenship?.name
    },
  },

  watch: {
    profileInfoP: {
      handler(val) {
        if (val) {
          this.userProfile = val
          this.mobile_number = val.mobile
          this.mobile_country_code = { precode: val.mobile_country_code }
        }
      },
      deep: true,
    },
    citizenshipName: {
      handler() {
        this.convertedBirthdate = moment(new Date(this.userProfile.profile.birth_date || new Date())).format('YYYY-MM-DD')
      },
      immediate: true,
    },
  },
  mounted() {
    formData.allproperties().then(res => {
      const result = res.data.results
      this.formsListData = result
      this.formsListData.pre_country_code = result.countries.map(item => ({
        // eslint-disable-next-line global-require, import/no-unresolved, import/no-dynamic-require
        precode: item.precode, id: item.id, name: item.name, image: require(`@/assets/images/flags/${item.abbreviation}.png`),
      }))
      if (this.profileInfoP && this.profileInfoP.profile) {
        this.userProfile = this.profileInfoP
        this.mobile_number = this.profileInfoP.mobile
        this.mobile_country_code = { precode: this.profileInfoP.mobile_country_code }
        this.convertedBirthdate = moment(new Date(this.profileInfoP.profile.birth_date || new Date())).format('YYYY-MM-DD')
      }
    })
  },
  methods: {
    async submit() {
      if (moment().diff(moment((this.convertedBirthdate)), 'days') <= moment().diff(moment().subtract(18, 'years').format('YYYY-MM-DD'), 'days')) {
        await this.$refs.generalTab.refs.birth_date.applyResult({
          errors: [this.$t('user_under_age_cant_register')], // array of string errors
          valid: false, // boolean state
          failedRules: {}, // should be empty since this is a manual error.

        })
        return
      }
      const success = await this.$refs.generalTab.validate()
      if (success) {
        this.pending = true
        const data = this.getData()
        userProfile.saveGeneral(data).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          if (res.status === 201) {
            this.$emit('update:active', 16)
          }
          userProfile.get().then(() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
          })
          this.pending = false
        }).catch(() => {
          this.pending = false
        })
      }
    },

    getData() {
      return {
        residency_id: this.userProfile.residency.id,
        citizenship_id: this.userProfile.citizenship.id,
        city: this.userProfile.city,
        first_name: this.userProfile.first_name,
        last_name: this.userProfile.last_name,
        gender_id: this.userProfile.profile.gender.id,
        birth_date: moment(this.convertedBirthdate).format('YYYY-MM-DD'),
      }
    },
    myFilter: (option, label, search) => {
      const temp = search.toLowerCase()
      return option.name.toLowerCase().indexOf(temp) > -1
          || option.precode.toString().toLowerCase().indexOf(temp) > -1
    },
    async SendCode() {
      this.codePending = true
      const data = { mobile: toEnglishDigits(this.mobile_number), mobile_country_code: this.mobile_country_code ? toEnglishDigits(this.mobile_country_code?.precode) : undefined }
      await userProfile.acceptMobile(data).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        userProfile.get()
        this.show = true
        // after input showed in dom, then select it.
        this.$nextTick(() => {
          const input = this.$refs.receive_code
          if (input) {
            input.focus()
          }
        })

        this.codePending = false
      }).catch(error => {
        this.codePending = false
        if (error.status === 422) {
          this.show = true
        } else {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }
      })
    },
    async RegisterCode() {
      this.registerPending = true
      const data = { code: toEnglishDigits(this.receive_code) }
      await userProfile.verifyMobile(data).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,

        })
        userProfile.get()
        this.registerPending = false
        this.show = false
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }).finally(() => {
        this.registerPending = false
      })
    },
  },

}
